import axios from '../../utils/axios';
import { objectToFormData } from '../utils';

// GET
//Api/Rental/CompaniesAndFacilities
export const getCompaniesAndFacilities = async () => {
  const response = await axios.get('Rental/CompaniesAndFacilities');
  return response.data;
};
// POST
//Api/Rental/EditSerialNumber or Api/Rental/EditPunchoutSerialNumber
export const postEditSerialNumber = async (cartItemId, newSerialNumber, isPunchoutOrder) => {
  const endpoint = isPunchoutOrder ? 'EditPunchoutSerialNumber' : 'EditSerialNumber';
  const formData = objectToFormData({ cartItemId, newSerialNumber });
  const response = await axios.post(`Rental/${endpoint}`, formData);
  return response.data;
};

export const getRentalPunchoutVendors = async (facilityId) => {
  const response = await axios.get(`Rental/GetRentalPunchoutVendors?facilityId=${facilityId}`);
  return response.data;
}

export const getFacilityName = async (facilityId) => {
  const response = await axios.get(`Rental/GetFacilityName?facilityId=${facilityId}`);
  return response.data;
}

export const getRentalsUnreadData = async () => {
  const response = await axios.get('/UnreadRentalCount');
  return response;
}

// POST
//Api/Rental/EditPersonFor
export const postEditPersonFor = async (orderId, residentId) => {
  const response = await axios.post(`Rental/EditPersonFor?orderId=${orderId}&residentId=${residentId}`);
  return response.data;
};

// GET
//Api/Rental/GetRentalRecipientsList
export const getRentalRecipients = async (orderId) => {
  const response = await axios.get(`Rental/GetRentalRecipientList?orderId=${orderId}`);
  return response.data;
};
// POST
//Api/Rental/UpdateOrderItems
export const sendPickupRequest = async ( orderCartItemIds, orderId, isPunchoutOrder ) => {
  const formData = new FormData();
  const pickupItems = orderCartItemIds?.map((item) => ({
    cartItemId: item,
    isSelected: true,
  }));
  pickupItems.forEach((item, index) => {
    Object.entries(item).forEach(([key, value]) => {
      formData.append(`${'orderCartItemIds'}[${index}].${key}`, value !== null && value !== '' ? value : '');
    });
  });
  formData.append('orderId', orderId)
  formData.append('isPunchoutOrder', isPunchoutOrder)
  formData.append('isPickupRequest', true)
  const response = await axios.post(`Rental/UpdateOrderItems`,formData);
  return response.data;
};// GET
//Api/Rental/Punchout?residentId=&vendorId=
export const punchoutOrder = async (residentId, vendorId, siteId, orderId = 0) => {
  const response = await axios.get(
    `/RentalPunchout/Punchout?residentId=${residentId}&vendorId=${vendorId}&siteId=${siteId}&orderId=${orderId}`
  );
  return response;
};

// GET
//Api/Rental/GetRentalRecipientsList
export const addCopiedUsers = async (copiedUsers, orderId) => {
  const formData = objectToFormData({ copiedUsers, orderId });
  const response = await axios.post(`Rental/AddRentalCopiedUsers`, formData);
  return response.data;
};

// GET
// Api/Category/CheckCategoryHasSubcategory; id
export const checkCategoryHasSubcategory = async (id) => {
  const response = await axios.get(`/Rental/CheckCategoryHasSubcategory?id=${id}`);
  return response;
};


// GET
//Api/Rental/GetRentalRecipientsList
export const deleteCopiedUser = async (copiedUser, orderId) => {
  const formData = objectToFormData({ copiedUser, orderId });
  const response = await axios.post(`Rental/DeleteCopiedUser`, formData);
  return response.data;
};

// GET
//Api/Rental/FacilityAccounts
export const getFacilityAccounts = async () => {
  const response = await axios.get('Rental/FacilityAccounts');
  return response.data;
};

export const getVendorFacilities = async () => {
  const response = await axios.get('Rental/VendorFacilities');
  return response.data;
};

export const postRentalVendorForm = async (form) => {
  const response = await axios.post('Rental/RentalVendorForm', objectToFormData(form));
  return response.data;
};

export const postRentalFacilityAccountForm = async (form) => {
  const response = await axios.post('Rental/RentalFacilityAccountForm', objectToFormData(form));
  return response.data;
};

export const postDeleteRentalVendor = async (id) => {
  const response = await axios.post(`Rental/DeleteRentalVendor?id=${id}`);
  return response.data;
};

export const postDeleteRentalFacilityAccount = async (id) => {
  const response = await axios.post(`Rental/DeleteRentalFacilityAccount?id=${id}`);
  return response.data;
};

export const getUOMTypes = async () => {
  const response = await axios.post('Rental/GetRentalBaseUOMTypes');
  return response.data;
}

export const getRentalLog = async (rentalId) => {
  const response = await axios.get(`Rental/GetRentalLog?rentalId=${rentalId}`);
  return response.data; 
}

export const addRentalLog = async (rentalId, messageType, extraInfo ) => {
  const formData = objectToFormData({ rentalId, messageType, extraInfo });    
  const response = await axios.post('Rental/AddRentalLog', formData);
  return response.data; 
}

export const deleteRentalLog = async (logId) => {
  const formData = objectToFormData({ logId });   
  const response = await axios.post('Rental/DeleteRentalLogMessage', formData);
  return response.data;
}

// GET
//Api/Rental/Categories
export const getCategories = async () => {
  const response = await axios.get('Rental/Categories');
  return response.data;
};

// GET
//Api/Rental/Residents facilityId
export const getResidents = async (facilityId) => {
  const response = await axios.get(`Rental/Residents?facilityId=${facilityId}`);
  return response;
};

// GET
//Api/Rental/FacilityVendors facilityId
export const getFacilityVendorsForFacility = async (facilityId) => {
  const response = await axios.get(`Rental/FacilityVendors?facilityId=${facilityId}`);
  return response;
};

// GET
//Api/Rental/Carts
export const getCarts = async () => {
  const response = await axios.get('Rental/Carts');
  return response;
};

// GET
//Api/Rental/facilityInfo facilityId
export const getFacilityInfo = async (facilityId) => {
  const response = await axios.get(`Rental/FacilityInfo?facilityId=${facilityId}`);
  return response;
};

// POST
//Api/Rental/CreateResident form
export async function postCreateResident(form, formFacilityId) {
  const updatedForm = {
    facilityId: formFacilityId,
    ...form,
  };

  const formData = objectToFormData(updatedForm);

  const response = await axios.post('Rental/CreateResident', formData);
  return response;
}

// GET
//Api/Rental/Items
export const getItems = async () => {
  const response = await axios.get('Rental/Items');
  return response;
};

// GET
//Api/Rental/ItemsByOrderId orderId
export const getItemsByOrderId = async (orderId) => {
  const response = await axios.get(`Rental/ItemsByOrderId?orderId=${orderId}`);
  return response;
};

// GET
//Api/Rental/Vendors
export const getVendors = async () => {
  const response = await axios.get(`Rental/Vendors`);
  return response;
};

export async function postAddToPunchoutCart(cartItemId, cartId, userId, pricingTypeId) {
  const formData = objectToFormData({
    cartItemId,
    cartId,
    userId,
    pricingTypeId
  });
  const response = await axios.post('Rental/AddToPunchoutCart', formData);
  return response;
};

// POST
//Api/AddToCart (when cart already exists) items array
export async function postAddToCart(itemId, cartId, userId, pricingTypeId) {
  const formData = objectToFormData({
    itemId,
    cartId,
    userId,
    pricingTypeId
  });
  const response = await axios.post('Rental/AddToCart', formData);
  return response;
}

// POST
//Api/AddToCart (create new cart) items array
export async function postAddNewCart(residentId, userId) {
  const formData = objectToFormData({
    residentId,
    userId,
  });
  const response = await axios.post('Rental/AddNewCart', formData);
  return response;
}

export async function postAddNewRentalOrder(itemsToAdd, selectedResident, selectedCategoryId, date) {
  const itemsToPost = itemsToAdd?.map((item) => ({
    itemId: item.itemId,
    quantity: item.quantity,
  }));
  const formData = objectToFormData({
   itemsToAdd: itemsToPost, selectedResident, selectedCategoryId, date
  });
  const response = await axios.post('Rental/AddNewRentalOrder', formData);
  return response.data;
}

// POST
//Api/AddToCart (create new cart) items array
export async function postAddItemsToOrder(items, orderId, orderStatus) {
   const itemsToPost = items?.map((item) => ({
      itemId: item.itemId,
      quantity: item.quantity,
  }));
  const formData = objectToFormData({ items: itemsToPost, orderId, orderStatus });
  const response = await axios.post('Rental/AddItemsToOrder', formData);
  return response;
}

// POST
//Api/Rental/RemoveFromCart cartItemId, deleteAll
export async function postRemoveCartItem(cartItemId, deleteAll) {
  const response = await axios.post(`Rental/RemoveCartItem?cartItemId=${cartItemId}&deleteAll=${deleteAll}`);
  return response;
}


// POST
//Api/Rental/RemovePunchoutFromCart cartItemId, deleteAll
export async function postRemovePunchoutCartItem(cartItemId, deleteAll) {
  const response = await axios.post(`Rental/RemovePunchoutCartItem?cartItemId=${cartItemId}&deleteAll=${deleteAll}`);
  return response;
}
//POST
//Api/Rental/postSubmitOrderApi items
export async function postSubmitOrderApi(items, isPunchoutOrder = false) {
  const formData = new FormData();
  const updateItems = items?.map((item) => ({
    cartItemId: item.cartItemId,
    isSelected: item.isSelected,
  }));
  updateItems.forEach((item, index) => {
    Object.entries(item).forEach(([key, value]) => {
      formData.append(`${'orderItems'}[${index}].${key}`, value !== null && value !== '' ? value : '');
    });
  });

  const response = await axios.post(`Rental/SubmitOrder?isPunchoutOrder=${isPunchoutOrder}`, formData);
  return response;
}
// GET
// /Api/Rental/RentalOrders
export const getRentalOrders = async (orderStatuses) => {
  const statuses = Array.isArray(orderStatuses) ? orderStatuses : [orderStatuses];
  const query = statuses.map(s => `orderStatus=${encodeURIComponent(s)}`).join('&');
  const response = await axios.get(`Rental/RentalOrders?${query}`);
  return response;
};

export async function postAddRentalNote({ message, orderId }) {
  const formData = new FormData();
  if (!message) return 
  if (message && message !== '' && message !== '<p><br></p>') formData.append('message', message);
  formData.append('orderId', orderId);
    await axios.post(`Rental/AddRentalNote`, formData);
}

export async function postAddRentalItemNote({ message, cartItemId }) {
  const formData = new FormData();
  if (!message) return 
  if (message && message !== '' && message !== '<p><br></p>') formData.append('message', message);
  formData.append('cartItemId', cartItemId);
  await axios.post(`Rental/AddRentalItemNote`, formData);
}

// POST
//Api/Rental/UpdateOrderStatus orderItems, isOrderRejected
export async function postUpdateOrderStatus(orderItems, isOrderRejected, orderId, isPunchoutOrder) {
  const formData = new FormData();
  const updateItems = orderItems?.map((item) => ({
    cartItemId: item.cartItemId,
    rejected: !!item.rejectedOn || (!isPunchoutOrder && item.itemId === 0) || item.vendorId === 0 || isOrderRejected || item.deleted === true,
  }));
  updateItems.forEach((item, index) => {
    Object.entries(item).forEach(([key, value]) => {
      formData.append(`${'orderItems'}[${index}].${key}`, value !== null && value !== '' ? value : '');
    });
  });
  formData.append('orderId', orderId)
  formData.append('isPunchoutOrder', isPunchoutOrder)
  const response = await axios.post('Rental/UpdateOrderStatus', formData);
  return response;
}

// POST
// /Api/OrderAsPDF
export async function getOrderAsPDF({ orderId, items, isPunchoutOrder }) {
  const formData = objectToFormData({ items, orderId, isPunchoutOrder });
  const response = await axios.post('Rental/OrderAsPDF', formData, { responseType: 'blob' });
  return response;
}

// POST
// /Api/OrderAsExcel
export async function getOrderAsExcel({ orderId, items, isPunchoutOrder }) {
  const formData = objectToFormData({  orderId, items, isPunchoutOrder });
  const response = await axios.post('Rental/OrderAsExcel', formData, { responseType: 'blob' });
  return response;
}

export async function getCatalogAsExcel() {
  const response = await axios.post('Rental/DownloadRentalCatalog', { responseType: 'blob' });
  return response;
}
// POST
//Api/Rental/UpdateOrderItems
export async function postCloseOrderItems(orderCartItemIds, orderId, isPunchoutOrder) {
  const formData = new FormData();
  const closeItems = orderCartItemIds?.map((item) => ({
    cartItemId: item,
    isSelected: true,
  }));
  closeItems.forEach((item, index) => {
    Object.entries(item).forEach(([key, value]) => {
      formData.append(`${'orderCartItemIds'}[${index}].${key}`, value !== null && value !== '' ? value : '');
    });
  });
  formData.append('orderId', orderId)
  formData.append('isPunchoutOrder', isPunchoutOrder)
  formData.append('isPickupRequest', false)
  const response = await axios.post('Rental/UpdateOrderItems', formData);
  return response;
}

// GET
// /Api/Rental/getIsAfterHours
export const getIsAfterHours = async () => {
  const response = await axios.get('Rental/IsAfterHours');
  return response;
};

// POST
// /Api/Rental/postIsApproveEnabled facilityId
export async function postIsApproveEnabled(facilityId, isPunchoutOrder) {
  const response = await axios.post(`Rental/CheckApprovePermission?facilityId=${facilityId}&isPunchoutOrder=${isPunchoutOrder}`);
  return response;
}

// POST
// /Api/SplitRentalOrder orderId items
export async function postSplitRentalOrder({ orderId, cartItemIds }) {
  const formData = objectToFormData({ 
    orderId, 
    cartItemIds 
  });
  const response = await axios.post('Rental/SplitOrder', formData);
  return response;
}

// POST
// /Api/SplitRentalOrder orderId items
export async function postSplitRentalPunchoutOrder({ orderId, cartItemIds }) {
  const formData = objectToFormData({ 
    orderId, 
    cartItemIds 
  });
  const response = await axios.post('Rental/SplitPunchoutOrder', formData);
  return response;
}

// POST
// /Api/Rental/postAddCategory name icon
export async function postAddCategory(name, icon) {
  const formData = objectToFormData({
    name,
    icon,
  });

  const response = await axios.post('Rental/AddCategory', formData);
  return response;
}

// POST
// /Api/Rental/postAddSubcategory subcategoryName, categoryId
export async function postAddSubcategory(subcategoryName, categoryId) {
  const response = await axios.post(
    `Rental/AddSubcategory?subcategoryName=${subcategoryName}&categoryId=${categoryId}`
  );
  return response;
}

// POST
// Api/Rental/postDeleteSubcategory; id substituteSubcategoryId substituteCategoryId
export const postDeleteSubcategory = async ({ id, substituteSubcategoryId, substituteCategoryId }) => {
  const formData = objectToFormData({
    id,
    substituteSubcategoryId,
    substituteCategoryId,
  });
  const response = await axios.post('Rental/DeleteSubcategory', formData);
  return response;
};
// POST
// Api/Rental/postDeleteSubcategory; id substituteSubcategoryId substituteCategoryId
export const postDeleteCategory = async ({ id }) => {
  const response = await axios.post(`Rental/DeleteCategory?id=${id}`);
  return response;
};

// GET
//Api/Rental/PricingTypes
export const getPricingTypes = async () => {
  const response = await axios.get(`Rental/PricingTypes`);
  return response;
};

// GET
//Api/Rental/UserRentals
export const getUserRentals = async (userEmail) => {
  const response = await axios.get(`Rental/UserRentals?userEmail=${userEmail}`);
  return response;
};

// GET
//Api/Rental/GetRentalOrderStatus
export const getRentalOrderStatus = async (rentalId) => {
  const response = await axios.get(`Rental/GetRentalOrderStatus?rentalId=${rentalId}`);
  return response;
}

//POST
//Api/Rental/postAddItem item
export const postAddItem = async (item) => {
  const formData = objectToFormData({
    description: item.description,
    notes: item.notes,
    categoryId: item.category.id,
    subcategoryId: item.subcategory.subcategoryId,
    vendorId: item.vendor.id,
    vendorItemId: item.vendorItemID,
    price: item.mainPrice,
    pricingTypeId: item.mainPricingType,
    pricingTypes: item.pricingTypes,
    image: item.imageUrl,
    uomAmount: item.uomAmount,
    uomType: item.uomType,
    capAmount: item.capAmount,
    vendorUrl: item.vendorItemLink,
    daysToCap: item.daysToCap,
    weightLimit: item.weightLimit,
    warranty: item.warranty
  });

  const response = await axios.post('Rental/AddItem', formData);
  return response;
};

//POST
//Api/Rental/postEditItem item
export const postEditItem = async (item) => {
  const formData = objectToFormData({
    description: item.description,
    notes: item.notes,
    categoryId: item.category.categoryId,
    subcategoryId: item.subcategory.subcategoryId,
    id: item.id,
    vendorId: item.vendorId,
    uomAmount: item.uomAmount,
    uomType: item.uomType,
    vendorUrl: item.vendorItemLink,
    price: item.price,
    pricingTypeId: item.pricingTypeId,
    image: item.image,
    capAmount: item.capAmount,  
    daysToCap: item.daysToCap,
    weightLimit: item.weightLimit,
    warranty: item.warranty,
    pricingTypes: item.pricingTypes
  });
  const response = await axios.post('Rental/EditItem', formData);
  return response;
};

// POST
//Api/Rental/postDeleteItem id
export async function postDeleteItem(id) {
  const response = await axios.post(`Rental/DeleteItem?id=${id}`);
  return response;
}

// POST
//Api/Rental/EditShortLongTerm cartItemId
export async function postEditShortLongTerm(cartItemId, isPunchoutOrder) {
  const response = await isPunchoutOrder ? axios.post(`Rental/EditPunchoutShortLongTerm?cartItemId=${cartItemId}`) : axios.post(`Rental/EditShortLongTerm?cartItemId=${cartItemId}`);
  return response;
}
// POST
//Api/Rental/EditPunchoutShortLongTerm cartItemId
export async function postEditPunchoutShortLongTerm(cartItemId) {
  const response = await axios.post(`Rental/EditPunchoutShortLongTerm?cartItemId=${cartItemId}`);
  return response;
}

// POST 
export async function postUpdateOrderPricingType(cartItemId, pricingTypeId) {
  const formData = objectToFormData({ cartItemId, pricingTypeId });
  const response = await axios.post('Rental/UpdateCartItemPricingType', formData);
  return response;
}

export async function postUpdatePunchoutCartItemSubcategory(cartItemId, subcategoryId) {
  const formData = objectToFormData({ cartItemId, subcategoryId });
  return axios.post('Rental/UpdatePunchoutCartItemSubcategory', formData);
}
// POST
//Api/Rental/EditRentalOrder
export async function updateRentalOrder(updatedOrderItem){
  const formData = objectToFormData(updatedOrderItem);
  const response = await axios.post(`Rental/EditRentalOrder`, formData);
  return response;
}
